module.exports = __webpack_public_path__ + "static/img/customer-02.1f1431b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sustainable/community/customer-02.png
// module id = acxa
// module chunks = 2